import { memo } from 'react';

import EllipsisTooltip from '@mindtickle/ellipsis-tooltip';

import { TEXT_TYPES } from '@mindtickle/styles/lib/classNames';
import { getPopupContainerOnBody } from '@mindtickle/utils';

import cs from 'classnames';
import { StyledLink, ELLIPSIS_TOOLTIP_STYLE } from './styles';
import { NavMenuItemProps } from './type';

const NavMenuItem = ({
  link,
  name,
  isActive,
  className,
  isPopoverContentLink,
  dataTestId,
}: NavMenuItemProps) => (
  <StyledLink
    data-testid={dataTestId}
    className={cs(`${TEXT_TYPES.LABEL_MEDIUM_DEFAULT} ${className || ''}`, {
      'active-route': isActive,
      'popover-content-link': isPopoverContentLink,
    })}
    to={link}
  >
    <EllipsisTooltip
      linesToClamp={1}
      overlayStyle={ELLIPSIS_TOOLTIP_STYLE}
      wrapperClassName="submenu-item-wrapper"
      title={name}
      getPopupContainer={getPopupContainerOnBody}
    >
      {name}
    </EllipsisTooltip>
  </StyledLink>
);

export default memo(NavMenuItem);
